const getRootExperimentationGroupSelector = (state) => state.workspace_data.workspace;
const getIsVNextExpManSelector = (state) => {
  const workspace = getRootExperimentationGroupSelector(state);
  const rootExperimentationGroup = workspace == null ? void 0 : workspace.data;
  if (!rootExperimentationGroup)
    return false;
  const { IsVNextExpMan } = rootExperimentationGroup;
  return !!IsVNextExpMan;
};
const getWSSPlitMigrationDataSelector = (state) => state.workspace_data.migration;
export {
  getIsVNextExpManSelector,
  getRootExperimentationGroupSelector,
  getWSSPlitMigrationDataSelector
};
//# sourceMappingURL=GetWorkspace.selectors.js.map
